module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.typeOne) ? _c('div', {
    staticClass: "layui-layer layui-layer-loading  layer-anim",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "margin-top": "-12px",
      "margin-left": "-30px",
      "z-index": "19891027"
    },
    attrs: {
      "id": "layui-loading-1",
      "type": "loading",
      "times": "1",
      "showtime": "0",
      "contype": "string"
    }
  }, [_c('div', {
    staticClass: "layui-layer-content layui-layer-loading0"
  }), _vm._v(" "), _c('span', {
    staticClass: "layui-layer-setwin"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08e58d52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmLoading.vue
// module id = 579
// module chunks = 2